import {
  PERMISSIONS,
  REPORT_PANELS,
  REPORT_PANEL_KEYS,
  ReportArea,
  type PermissionGrant,
  type ReportPanel,
} from '@optiflow/types';
import { hasAllPermissions, hasPermission } from './permissions.util';

/** The panels these grants may see, each judged on its own complete permission set. */
export function authorisedReportPanels(
  grants: readonly PermissionGrant[] | undefined,
): ReportPanel[] {
  return REPORT_PANEL_KEYS.filter((panel) =>
    hasAllPermissions(grants, REPORT_PANELS[panel].requires),
  );
}

/**
 * Whether a report area should appear in navigation.
 *
 * A tab shows when at least one panel inside it is authorised; this is convenience, never
 * security — every panel is enforced again on the server.
 */
export function reportAreaVisible(
  grants: readonly PermissionGrant[] | undefined,
  area: ReportArea,
): boolean {
  if (!hasPermission(grants, PERMISSIONS.REPORTING_VIEW)) return false;
  if (area === ReportArea.OVERVIEW) return true;
  return authorisedReportPanels(grants).some((panel) => REPORT_PANELS[panel].area === area);
}

export function canExportReports(grants: readonly PermissionGrant[] | undefined): boolean {
  return (
    hasPermission(grants, PERMISSIONS.REPORTING_VIEW) &&
    hasPermission(grants, PERMISSIONS.REPORTING_EXPORT)
  );
}
